export const themeKeys = ["light", "dark"] as const
export const breakpoints = ["", "_sm", "_md", "_lg", "_xl"]
export type Theme = (typeof themeKeys)[number]

export type ResponsiveVariable<T> = {
  default?: T
  tablet?: T
  desktop?: T
}
